import { useState, useEffect, useMemo } from "react";
import {
  Box,
  Button,
  FormControl,
  Grid,
  IconButton,
  MenuItem,
  Select,
  Tooltip,
  Typography,
  useMediaQuery,
} from "@mui/material";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import Breadcrumbs from "./BreadCrumbs";
import { CmpDatePickerField001V1 } from "../../Component/Common/ToolBox/ToolBoxV1";
import GCAutocompleteCheckboxFixSizeUid from "./GCAutocompleteCheckboxFixSizeUid";
import {
  fcheck_null_undefine_replace_empty,
  getStatusStyleV1,
} from "../../Utility/Utilitys";
import { IMOQCRA_Summary } from "../../Server/ApiV2";
import {  Head_Set } from "./SliceMoqDetail";
import { vRdxUserInfo } from "../../Redux/roStore";
import { DataGridPro, useGridApiRef,gridRowIdsSelector } from "@mui/x-data-grid-pro";
import DownloadOutlinedIcon from "@mui/icons-material/DownloadOutlined";
import PrintOutlinedIcon from "@mui/icons-material/PrintOutlined";

export default function ItemMoqRequest() {
  const isMobile = useMediaQuery("(max-width:650px)");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const apiRef = useGridApiRef();

  const statusOptions = ["All", "Enter", "Post"];
  const vRdxUserInfoObj = vRdxUserInfo();
  const vRdxHead = useSelector(
    (state) => state.SliceMoqRequest.value.SummaryHead
  );
  const vRdxuserLoc = useSelector(
    (state) => state.SliceDB.value.Location.LocWithRights
  );

  const [rows, setRows] = useState([]);
  const [filterObj, setFilterObj] = useState({
    dateFrom: moment().startOf("month").toDate(),
    dateTo: moment().toDate(),
    location: vRdxuserLoc?.map((item) => item.Uid),
    status: "All", 
  });

  const handleRowClick = (params) => {
    dispatch(
      Head_Set({
        ...vRdxHead,
        A_Transid: params.row?.A_Transid,
        A_Date: params.row?.A_Date,
        A_Location: params.row?.A_Location,
        Loc_Name: params.row?.Loc_Name,
        A_Narration: params.row?.A_Narration,
        A_Status: params.row?.A_Status,
        CreatedBy: params.row?.CreatedBy,
        CreatedDate: params.row?.CreatedDt,
        VendorName: params.row?.VendorName,
        VendorCd: params.row?.A_Vendor,
        A_Locationcsv: params.row?.A_Locationcsv,
        ApproveStatus: params.row?.ApproveStatus,
        A_Vendor: params.row?.A_Vendor,
        LPOGruppen: params.row?.LPOGruppen,
        A_Status_CM: params.row?.A_Status_CM,
        A_Status_PM: params.row?.A_Status_PM,
      })
    );
    navigate("/ItemMoqDetail");
  };

  const handleNew = () => {
    dispatch(
      Head_Set({
        A_Transid: 0,
        A_Date: new Date(),
        A_Location: vRdxuserLoc?.length > 0 ? vRdxuserLoc[0]?.Uid : "",
        Loc_Name: "",
        A_Narration: "",
        A_Status: "ENTER",
        CreatedBy: "",
        CreatedDate: "",
        VendorName: "",
        VendorCd: "",
        A_Locationcsv: "",
        LPOGruppen: "",
        A_Status_CM: "",
        A_Status_PM: "",
      })
    );
    navigate("/ItemMoqDetail");
  };

  const handleExport = () => {
    apiRef.current.exportDataAsCsv({
      getRowsToExport: ({ apiRef }) => gridRowIdsSelector(apiRef),
      includeHeaders: true,
      utf8WithBom: true,
    });
  };
  const handlePrint = () => {
    apiRef.current.exportDataAsPrint();
  };
  const loadSummary = async () => {
    const locationStr = Array.isArray(filterObj?.location)
      ? filterObj?.location.join(",")
      : filterObj?.location || "";
    const response = await IMOQCRA_Summary(
      fcheck_null_undefine_replace_empty({
        FromDate: filterObj?.dateFrom
          ? moment(filterObj?.dateFrom).format("MM/DD/YYYY")
          : "",
        ToDate: filterObj?.dateTo
          ? moment(filterObj?.dateTo).format("MM/DD/YYYY")
          : "",
        Location: locationStr,
        Status: filterObj?.status || "",
        UserCd: vRdxUserInfoObj?.UserID || "",
      })
    );
    if (response?.status === 200) {
      setRows(response?.data?.recordset || []);
    }
  };

  return (
    <>
    <div className="div-container">
      <Box sx={{ mt: { xs: 2, md: 0 } }}>
        <Breadcrumbs />
      </Box>
      <Grid
        container
        spacing={{ xs: 1.5, md: 1 }}
        sx={{ alignItems: { xs: "flex-end" }, mt: { xs: 1, sm: 0 } }}
      >
        <Grid item xs={6} sm={3} md={2.5} lg={1.5}>
          <CmpDatePickerField001V1
            xLabelText="From Date"
            xValue={filterObj.dateFrom}
            xOnChange={(val) =>
              setFilterObj((p) => ({ ...p, dateFrom: val?.$d ?? val }))
            }
          />
        </Grid>
        <Grid item xs={6} sm={3} md={2.5} lg={1.5}>
          <CmpDatePickerField001V1
            xLabelText="To Date"
            xValue={filterObj.dateTo}
            xOnChange={(val) =>
              setFilterObj((p) => ({ ...p, dateTo: val?.$d ?? val }))
            }
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4.5} lg={4}>
          <Typography>Location</Typography>
          <GCAutocompleteCheckboxFixSizeUid
            xLabelText="Location"
            options={vRdxuserLoc ?? []} /* 🔹 use Redux list directly */
            xValue={filterObj.location} /* array of UIDs */
            setValue={(updated) =>
              setFilterObj((p) => ({ ...p, location: updated }))
            }
            objName="location"
            placeholder="Search Location"
          />
        </Grid>
        <Grid item xs={12} sm={3} md={2.5} lg={1.5}>
          <Typography>Status</Typography>
          <FormControl fullWidth>
            <Select
              size="small"
              value={filterObj.status || ""}
              onChange={(e) =>
                setFilterObj((p) => ({ ...p, status: e?.target?.value }))
              }
            >
              {statusOptions.map((status) => (
                <MenuItem key={status} value={status}>
                  {status}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid
          item
          xs={12}
          sm={9}
          md={12}
          lg={3.5}
          container
          justifyContent="flex-end"
        >
          <Box display="flex" flexWrap="wrap" gap={1}>
            <Button
              variant="contained"
              size="small"
              onClick={() => loadSummary()}
              sx={{ minWidth: { xs: "auto", sm: 100 } }}
            >
              Load
            </Button>
            <Button
              variant="contained"
              size="small"
              onClick={handleNew}
              sx={{ minWidth: { xs: "auto", sm: 100 } }}
            >
              New
            </Button>
            <Tooltip title="Export CSV">
              <IconButton color="primary" onClick={handleExport} size="small">
                <DownloadOutlinedIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title="Print">
              <IconButton color="primary" onClick={handlePrint} size="small">
                <PrintOutlinedIcon />
              </IconButton>
            </Tooltip>
          </Box>
        </Grid>
      </Grid>
      <Box
        sx={{
          height: { xs: "54vh", sm: "70vh", md: "74vh", lg: "80vh" },
          marginTop: 1,
        }}
      >
        <DataGridPro
          rowHeight={30}
          apiRef={apiRef}
          headerHeight={40}
          rows={rows}
          getRowId={(row) => row.A_Transid}
          onRowDoubleClick={handleRowClick}
          columns={[
            {
              field: "A_Transid",
              headerName: "Trans ID",
              width: 70,
              align: "center",
            },
            {
              field: "A_Date",
              headerName: "Date",
              width: 85,
              align: "center",
              valueFormatter: ({ value }) =>
                moment(value).isValid()
                  ? moment(value).format("DD/MM/YYYY")
                  : "",
            },
            { field: "Loc_Name", headerName: "Trans Location", width: 100 },
            { field: "VendorName", headerName: "Vendor Name", width: 100 },
            {
              field: "LPOGruppenName",
              headerName: "LPO Group",
              width: 120,
            },
            {
              field: "A_Narration",
              headerName: "Narration",
              minWidth: 160,
              flex: 1,
              hide: isMobile,
            },
            {
              field: "A_Status",
              headerName: "Status",
              width: 75,
              renderCell: (params) => {
                const style = getStatusStyleV1(params.value);
                return (
                  <div
                    style={{
                      ...style,
                      padding: "2px 8px",
                      borderRadius: "4px",
                      textAlign: "center",
                      width: "100%",
                      fontWeight: "bold",
                    }}
                  >
                    {params.value}
                  </div>
                );
              },
            },
            {
              field: "A_Status_CM",
              headerName: "CM Status",
              width: 80,
              renderCell: (params) => {
                const style = getStatusStyleV1(params.value);
                return (
                  <div
                    style={{
                      ...style,
                      padding: "2px 8px",
                      borderRadius: "4px",
                      textAlign: "center",
                      width: "100%",
                      fontWeight: "bold",
                    }}
                  >
                    {params.value}
                  </div>
                );
              },
            },
            {
              field: "A_Status_PM",
              headerName: "PM Status",
              width: 75,
              renderCell: (params) => {
                const style = getStatusStyleV1(params.value);
                return (
                  <div
                    style={{
                      ...style,
                      padding: "2px 8px",
                      borderRadius: "4px",
                      textAlign: "center",
                      width: "100%",
                      fontWeight: "bold",
                    }}
                  >
                    {params.value}
                  </div>
                );
              },
            },
            {
              field: "ApproveStatus",
              headerName: "Appr Status",
              width: 90,
              renderCell: (params) => {
                const style = getStatusStyleV1(params.value);
                return (
                  <div
                    style={{
                      ...style,
                      padding: "2px 8px",
                      borderRadius: "4px",
                      textAlign: "center",
                      width: "100%",
                      fontWeight: "bold",
                    }}
                  >
                    {params.value}
                  </div>
                );
              },
            },
            {
              field: "CreatedBy",
              headerName: "Created By",
              width: 110,
            },
            {
              field: "CreatedDt",
              headerName: "Created Date",
              width: 95,
              align: "center",
              valueFormatter: ({ value }) =>
                moment(value).format("DD/MM/YYYY") == "Invalid date"
                  ? ""
                  : moment(value).format("DD/MM/YYYY"),
            },
            {
              field: "A_CM_By",
              headerName: "Appr By CM",
              width: 110,
            },
            {
              field: "A_CM_Dt",
              headerName: "CM Appr Date",
              width: 100,
              align: "center",
              valueFormatter: ({ value }) =>
                moment(value).format("DD/MM/YYYY") == "Invalid date"
                  ? ""
                  : moment(value).format("DD/MM/YYYY"),
            },
            {
              field: "A_PM_By",
              headerName: "Appr By PM",
              width: 110,
            },
            {
              field: "A_PM_Dt",
              headerName: "PM Appr Date",
              width: 100,
              align: "center",
              valueFormatter: ({ value }) =>
                moment(value).format("DD/MM/YYYY") == "Invalid date"
                  ? ""
                  : moment(value).format("DD/MM/YYYY"),
            },
            {
              field: "ApprovedBy",
              headerName: "Confirm By",
              width: 110,
            },
            {
              field: "ApproveDt",
              headerName: "Confirm Date",
              width: 95,
              align: "center",
              valueFormatter: ({ value }) =>
                moment(value).format("DD/MM/YYYY") == "Invalid date"
                  ? ""
                  : moment(value).format("DD/MM/YYYY"),
            },
          ]}
          hideFooter
          getRowClassName={(params) =>
            params.indexRelativeToCurrentPage % 2 === 0
              ? "mui-even-row"
              : "mui-odd-row"
          }
          sx={{
            border: 1,
            borderColor: "primary.light",
            "& .MuiDataGrid-columnHeaders": {
              backgroundColor: "#0d73bb",
              color: "white",
            },
          }}
        />
      </Box>
      </div>
    </>
  );
}
